import React from 'react';
import ReactDOM from 'react-dom';
import retargetEvents from 'react-shadow-dom-retarget-events';
import FormContact from './form-contact.jsx';

export default class FormContactWrapper extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  connectedCallback() {
    this.mountPoint = document.createElement('div');
    this.mountPoint.className = 'wrapper__component';
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(this.mountPoint);

    const createForm = () => React.createElement(
      FormContact,
      {},
      React.createElement('slot'),
    );

    ReactDOM.render(createForm(), this.mountPoint);
    retargetEvents(shadowRoot);
  }
}

window.customElements.define('form-contact', FormContactWrapper);
